import { createApp, ref, onMounted } from 'vue'
import vueObserver from '@remote/plugins/vue-observer'
import VueSee from '@remote/plugins/vue-see'
import statPlugin from '@remote/plugins/stat'
import vueLongpress from '@remote/plugins/vue-longpress'
import PromisifyDialog from '@shared/components/PromisifyDialog.vue'
import { Store } from 'pinia'
let zIndex = 999
let floatupIndex = 999

export const isMaxFloatupIndex = (index: number) => {
  return index >= floatupIndex
}

export const getFloatupIndex = () => {
  return floatupIndex+=1
}

export const promisifyDialog = <T extends PromisifyDialog>(component: T, props: PromisifyDialogProps<T> = {}, injectedStore?:Store<string, any, any>): PromisifyDialogReturn<T> => {
  let unmount: (() => void) | null = null
  return new Promise((resolve, reject) => {
    const dialog = createApp(PromisifyDialog, {
      dialogProps: props,
      dialog: component,
      resolve,
      reject,
    })
    dialog.directive(vueObserver.name, vueObserver.action)
    dialog.directive(VueSee.name, VueSee.directive)
    dialog.directive(vueLongpress.name, vueLongpress.action)
    dialog.use(statPlugin)
    if (injectedStore) dialog.use(injectedStore)
    const mountPoint = document.createElement('div')
    document.body.appendChild(mountPoint)
    dialog.mount(mountPoint)
    unmount = dialog.unmount
  }).then((res) => {
    if (unmount && typeof unmount === 'function') {
      unmount()
    }
    return res as PromisifyDialogReturn<T>
  })
}

/**
 * 弹窗 Promise 化
 * 需要给组件定义包括'dialog-close'的emit类型，然后将emit函数传入
 */
export const usePromisifyDialog = <T>(emit: (event: 'dialog-close', ret: T) => void) => {
  /**
   * 弹窗是否展示，将这个传给 el-dialog 的 modelValue
   * 展示和关闭弹窗都要 setTimeout 0 再执行的原因是可以让 el-dialog 有渐变动画
   */
  const isShow = ref(false)
  /**
   * 关闭弹窗
   * 传入参数会返回到 Promise 的结果
   */
  const close = (ret: T) => {
    zIndex+=1
    isShow.value = false
    setTimeout(() => {
      emit('dialog-close', ret)
    }, 300)
  }

  onMounted(() => {
    zIndex-=1
    setTimeout(() => {
      isShow.value = true
    }, 0)
  })

  return {
    isShow,
    close,
    zIndex,
  }
}